import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';

const VisuallyHiddenField = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  pointer-events: none;
`;

export default function InputField(props) {
  const { label, name, ...other } = props;
  const [field, meta, helpers] = useField(props);
  const isInvalid = meta.touched && meta.error;

  const labelClassName = props.labelClassName

  return (
    <div className=" mt-5 text-12px leading-normal opacity-90 select-none">
      <div onClick={() => helpers.setValue(!!!meta.value)} className="inline-flex cursor-pointer group">
        <div className="flex items-start -ml-4">
          <div className="pl-4 mt-0.5">
            <button
              className={`h-3 w-3 border opacity-100 transition-opacity duration-200 group-hover:opacity-50 ${meta.value === true ? `bg-black` : isInvalid ? 'border-[#ff0000]' : ''} `}
              type="button"
              role="checkbox"
            />
          </div>
          <div className={`pl-4 ${labelClassName}`} dangerouslySetInnerHTML={{ __html: label }} />

          {name === 'acceptTerms' && <VisuallyHiddenField><input type="text" name="optin" value={meta.value === true ? '1': ''} /></VisuallyHiddenField>}
        </div>
      </div>
    </div>
  );
}
